var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInventoryIcon = function SvgInventoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.333 4.286H14m-6.667 4H14m-6.667 4H14M2 5.217s.667.434 1 1.07c0 0 1-2.5 2.333-3.333M2 12.55s.667.434 1 1.07c0 0 1-2.5 2.333-3.332"
  })));
};
export default SvgInventoryIcon;